import React, { createContext, useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import ReactDOMServer from 'react-dom/server';
import PubSub from 'pubsub-js'
import { useParams } from "react-router-dom";
import { useImmer } from 'use-immer';
import { Button, Card, Row, Form, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment-business-days';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import CodingEventDocuments from '../codingevent/form/CodingEventDocuments';
import { TabItem, TabList } from '../../controls';
import CustomerCodingEventService from '../../services/CustomerCodingEventService';
import { jsPDF } from "jspdf";
import CustomerWorksheetPrint from './CustomerWorksheetPrint';
import { useContext } from 'react';
import { CustomerContext } from '../../contexts/CustomerContext';
import parse from "html-react-parser";
import { ConditionalRender } from '../../controls/formControls';
import AudienceList from '../../controls/message/AudienceList';
import MessageList from '../../controls/message/MessageList';
import { AuthContext } from '../../contexts/AuthContext';
import CodingEventStartReply from '../../controls/message/CodingEventStartReply';
import JoinLeaveMessageAudience from '../../controls/message/JoinLeaveMessageAudience';
import RenderInWindow from '../../controls/RenderInWindow';
import NewWindow from 'react-new-window'
import logoBig from '../../assets/img/brand/logoBig.png';

const CustomerCodingEvent = (props) => {
    const [codingEvent, setCodingEvent] = useImmer({ description: '', documents: [], worksheets: [], messages: [] });
    const [currentUserId, setCurrentUserId] = useState();
    const [eventPriorities, setEventPriorities] = useImmer([])
    const [isDirty, setIsDirty] = useState(false);
    const [origCodingEvent, setOrigCodingEvent] = useState({});
    const [isCustomerAdmin, setIsCustomerAdmin] = useState(false);
    const [worksheetPrintView, setWorksheetPrintView] = useState(null);

    const { id } = useParams();
    const customerContext = useContext(CustomerContext);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        setCurrentUserId(authContext.currentUser.id);
        var isAdmin = authContext.hasPermission(authContext.claims.canCrudCustomerCodingQueue, authContext.claimValues.createReadUpdateDelete);
        setIsCustomerAdmin(isAdmin);
    }, [])

    useEffect(() => {
        if (id !== undefined) {
            getCodingEvent(id);
        }
    }, [id])


    const getCodingEvent = async (id) => {
        var eventService = new CustomerCodingEventService();
        var results = await eventService.getEvent(id);
        if (results.result) {
            const codingEvent = results.model.codingEvent;
            codingEvent.newNote = '';
            setEventPriorities(results.model.priorities);
            setCodingEvent(codingEvent);
            setOrigCodingEvent(codingEvent);
            setIsDirty(false);

            //setRefData(_.omit(results.model, "codingEvent"));
        } else {
            //set some error srate here?
        }
    }

    const updateCustomerPriority = (id) => {
        const targetValue = id;
        if (codingEvent.customerPriorityId != targetValue) {
            setCodingEvent(draft => {
                draft.customerPriorityId = id;
            });
        }
    }

    const saveEvent = () => {
        saveCustomerPriority();
    }

    const resetModel = () => {
        setCodingEvent(origCodingEvent);
        setIsDirty(false);
    }

    const saveCustomerPriority = async () => {
        var eventService = new CustomerCodingEventService();
        var results = await eventService.updateCustomerPriority(codingEvent.customerPriorityId, codingEvent.id);
        if (results.result) {
            setOrigCodingEvent(codingEvent);
            setIsDirty(false);
        } else {
            customerContext.showModal({
                open: true,
                message: parse(`There was an error updating this event.<br/><br/>${results.message}`),
                title: `Failed to update event`,
                closeModal: customerContext.hideModal
            }, 'errorModal')
        }
    }

    useEffect(() => {
        if (codingEvent.customerPriorityId !== origCodingEvent.customerPriorityId) {
            setIsDirty(true);
        }
    }, [codingEvent.customerPriorityId])

    const downloadWorksheet = async (id) => {

        var eventService = new CustomerCodingEventService();
        var callResult = await eventService.getWorksheet(id);

        if (callResult.result) {
            let vm = callResult.model.codingEventWorksheet;
            var info = vm.worksheetAnswers.information;
            var title = "Undefined"
            var modalTitle = ""
            if (info != undefined) {
                var assessmentDate = (info.ASSESSMENT_DATE ?? "NULL");
                var oasisType = (info.OASIS_TYPE ?? "NULL").replaceAll(' ', '-')
                var patientIdMrn = (info.PATIENT_ID_MRN ?? "NULL").replaceAll(' ', '-')
                var clinician = (info.AUTHORING_CLINICIAN ?? "NULL").replaceAll(' ', '-')
                title = `${assessmentDate}_${oasisType}_${patientIdMrn}_${clinician}`
                modalTitle = `${assessmentDate} ${(info.OASIS_TYPE ?? "NULL")} ${(info.PATIENT_ID_MRN ?? "NULL")} ${(info.AUTHORING_CLINICIAN ?? "NULL")}`
            }

            var controlToPrint = <CustomerWorksheetPrint worksheet={vm.worksheet} answers={vm.worksheetAnswers} />;

            customerContext.showModal({
                open: true,
                documentTitle: title,
                title: modalTitle,
                controlToPrint: controlToPrint,
                modalClassName: "modal-xxl",
                closeModal: customerContext.hideModal
            }, 'printViewModal')
        }
    }

    const messageChangedCallback = async () => {
        await getCodingEvent(id);
        authContext.hideModal();
    }

    const addFile = (file) => {
        setCodingEvent(draft => {
            draft.documents.push(file);
        });
    }

    const removeFile = (id) => {
        setCodingEvent(draft => {
            draft.documents = draft.documents.filter(doc => doc.id !== id);
        });
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >
                    {"Event #: " + codingEvent.id + " - "} {codingEvent.description.length > 80 ? (codingEvent.description.substring(0, 80) + " ...") : codingEvent.description}
                </div>
                <div className="card-btn-group">

                    <ConditionalRender visible={!isDirty}>
                        <LinkContainer to={'/customer/queue'}>
                            <Button variant="secondary" size="sm">Close</Button>
                        </LinkContainer>
                    </ConditionalRender>
                    <ConditionalRender visible={isDirty}>
                        <Button variant="secondary" size="sm" onClick={() => resetModel()}>Undo Changes</Button>
                        <Button variant="success" size="sm" onClick={() => saveEvent()}>Save</Button>
                    </ConditionalRender>
                </div>
            </Card.Header>
            <Card.Body>
                {/*{JSON.stringify(codingEvent, null, 2)}*/}
                <Row>
                    <Form.Group as={Col} lg="6" md="6">
                        <Form.Label>Description</Form.Label>
                        <Form.Control placeholder="" name="description" id="description" readOnly plaintext value={codingEvent.description} />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Line of Business</Form.Label>
                        <Form.Control placeholder="" name="lob" id="lob" readOnly plaintext value={codingEvent.lineOfBusinessName} />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Service Requested</Form.Label>
                        <Form.Control placeholder="" name="serviceRequested" id="serviceRequested" readOnly plaintext value={codingEvent.serviceRequestName} />
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Customer Name</Form.Label>
                        <Form.Control placeholder="" name="customerName" id="customerName" readOnly plaintext value={codingEvent.customerAccountName} />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Customer Contact</Form.Label>
                        <Form.Control placeholder="" name="customerContact" id="customerContact" readOnly plaintext value={codingEvent.customerContactName} />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Assigned To</Form.Label>
                        <Form.Control placeholder="" name="assignedTo" id="assignedTo" readOnly plaintext value={codingEvent.assignedToName} />
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Status</Form.Label>
                        <Form.Control placeholder="" name="status" id="status" readOnly plaintext value={codingEvent.statusName} />
                    </Form.Group>
                    <Form.Group as={Col} lg="6" md="6">
                        <Form.Label>Status Reason</Form.Label>
                        <Form.Control placeholder="" name="statusReason" id="statusReason" readOnly plaintext value={codingEvent.statusReason} />
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Priority</Form.Label>
                        <Form.Control placeholder="" name="priority" id="priority" readOnly plaintext value={codingEvent.eventPriorityName} />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Customer Priority</Form.Label>
                        <ConditionalRender visible={isCustomerAdmin}>
                            <Form.Control as="select"
                                value={codingEvent.customerPriorityId}
                                onChange={(e) => updateCustomerPriority(parseInt(e.target.value))}
                                name="customerPriorityId">
                                {
                                    eventPriorities.map((opt, idx) => {
                                        return <option key={idx} value={opt.id}>{opt.name}</option>
                                    })
                                }
                            </Form.Control>
                        </ConditionalRender>
                        <ConditionalRender visible={!isCustomerAdmin}>
                            <Form.Control placeholder="" name="customerPriorityName" id="customerPriorityName" readOnly plaintext value={codingEvent.customerPriorityName} />
                        </ConditionalRender>
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Received On</Form.Label>
                        <Form.Control placeholder="" name="receivedOn" id="receivedOn" readOnly plaintext value={moment(codingEvent.receivedOn).format('MM/DD/YYYY h:mm a')} />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <Form.Label>Due By</Form.Label>
                        <Form.Control placeholder="" name="dueBy" id="dueBy" readOnly plaintext value={codingEvent.dueBy != null ? moment(codingEvent.dueBy).format('MM/DD/YYYY h:mm a') : "Pending"} />
                    </Form.Group>
                </Row>
                <div className="d-flex align-items-center">
                    <div className="mr-auto"><b>Completed Worksheets</b></div>
                </div>
                <div>
                    <table className='table' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Version</th>
                                <th>Started On</th>
                                <th>Status</th>
                                <th className="table-fit"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {codingEvent.worksheets.map((worksheet) =>
                                <tr key={worksheet.id}>
                                    <td>{worksheet.name}</td>
                                    <td>{worksheet.version}</td>
                                    <td>{moment(worksheet.dateCreated).format('MM/DD/YYYY h:mm a')}</td>
                                    <td>{worksheet.statusName}</td>
                                    <td className="table-fit">
                                        <FontAwesomeIcon icon={faDownload} onClick={() => window.open("/customer/worksheet/" + worksheet.id, "_blank")} className="secondary-icon" />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {worksheetPrintView}
                </div><br /><br />
                <TabList>
                    <TabItem label="Associated Files" isTable>
                        <CodingEventDocuments
                            documents={codingEvent.documents}
                            codingEventId={codingEvent.id}
                            onFileDeleted={(id) => removeFile(id)}
                            onFileAdded={(file) => addFile(file)}
                        />
                    </TabItem>
                    <TabItem label="Messages" isTable>
                        <AudienceList message={codingEvent?.message} updateCallback={messageChangedCallback}>
                            <JoinLeaveMessageAudience message={codingEvent?.message} currentUserId={currentUserId} updateCallback={messageChangedCallback} />
                            <CodingEventStartReply currentUserId={currentUserId} messageChangedCallback={messageChangedCallback} codingEvent={codingEvent} />
                        </AudienceList>
                        <MessageList message={codingEvent?.message} currentUserId={currentUserId} />
                    </TabItem>
                </TabList>
                {/*<Row>*/}

                {/*Coding Event<br />*/}
                {/*need - read only view of most items<br />*/}
                {/*need customer priority to show for admins<br />*/}
                {/*need ability to add documents to coding event<br />*/}
                {/*need to be able to launch a message connected with the coding event<br />*/}
                {/*</Row>*/}
            </Card.Body>
        </Card>
    )
}

export default CustomerCodingEvent;